import apiClient from "./api";

export interface TechnicalDocSummary {
  id: string;
  title: string;
  summary: string;
  lastUpdated: string;
}

export interface TechnicalDocDetail extends TechnicalDocSummary {
  markdown: string;
  fileName: string;
}

export const technicalDocsService = {
  list: (): Promise<TechnicalDocSummary[]> =>
    apiClient.get("/technical-docs").then((r) => r.data),

  getById: (id: string): Promise<TechnicalDocDetail> =>
    apiClient.get(`/technical-docs/${id}`).then((r) => r.data),

  /**
   * Resolved download URL. The endpoint returns the markdown as a file
   * (`Content-Disposition: attachment`), so the browser saves rather than
   * renders. Used as the `href` of an `<a download>` link.
   */
  downloadUrl: (id: string): string =>
    `${apiClient.defaults.baseURL}/technical-docs/${id}/download`,
};
